module.exports = __webpack_public_path__ + "img/email-mark-as-unread.f20f0246.svg";